import React from "react";
import { Box, IconButton, useTheme } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Typography from "components/basic/typography";

import { PAGE_SIZE } from "../../constants";

interface PagerProps {
  page: number;
  total: number;
  onPageChange: (page: number) => void;
}

const Pager: React.FC<PagerProps> = ({ page, total, onPageChange }) => {
  const theme = useTheme();
  const first = total === 0 ? 0 : page * PAGE_SIZE + 1;
  const last = Math.min((page + 1) * PAGE_SIZE, total);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="flex-end"
      gap={1}
      px={{ xs: 2, md: 3 }}
      py={1}
    >
      <Typography
        variant="body2"
        style={{ color: theme.palette.text.secondary }}
      >
        {first}–{last} of {total}
      </Typography>
      <IconButton
        size="small"
        disabled={page === 0}
        onClick={() => onPageChange(page - 1)}
        aria-label="Previous page"
      >
        <ChevronLeftIcon />
      </IconButton>
      <IconButton
        size="small"
        disabled={last >= total}
        onClick={() => onPageChange(page + 1)}
        aria-label="Next page"
      >
        <ChevronRightIcon />
      </IconButton>
    </Box>
  );
};

export default Pager;
